<template>
  <div>
    <feather type="plus" stroke="#4050F6" stroke-width="6" size="22px" fill="#4050F6" v-b-modal.modal-StoreAdd></feather>
    <b-modal size="xl" id="modal-StoreAdd" title="Create store" @show="OnShowModal" @hide="clear" hide-footer
      no-close-on-esc no-close-on-backdrop>
      <div class="container-fluid">
        <b-modal ref="StoreAddAlert" title="Admin" @ok="close()" ok-only>
          <p class="my-4">{{ message }}</p>
        </b-modal>
        <b-modal id="StoreDeleteModal" title="Admin" @ok="deleteRow(id)">
          <p class="my-4">Are you sure you want to delete this slider?</p>
        </b-modal>
        <div class="text-right">
          <b-form-checkbox switch size="s" v-model="form.status">Active</b-form-checkbox>
        </div>
        <hr>
        <div class="row product-adding">
          <div class="col-xl-12">
            <div class="row product-adding">
              <div class="col-xl-6">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationstorename" class="col-form-label pt-0">Store title
                      <span>*</span></label>
                    <ValidationProvider name="title" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstorename" type="text" v-model="form.title" required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="validationstorehostname" class="col-form-label pt-0">Store Hostname
                      <span>*</span></label>
                    <ValidationProvider name="host" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstorehostname" type="text" v-model="form.host"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="validationstoreemail" class="col-form-label pt-0">Store email</label>
                    <input class="form-control" id="validationstoreemail" type="email" v-model="form.email" />
                  </div>
                  <div class="form-group">
                    <label for="validationstorephone" class="col-form-label pt-0">Store phone</label>
                    <input class="form-control" id="validationstorephone" type="tel" v-model="form.phone" required="" />
                  </div>
                  <div class="form-group">
                    <label for="validationstoreaddress" class="col-form-label pt-0">Store address</label>
                    <input class="form-control" id="validationstoreaddress" type="text" v-model="form.adresse"
                      required="" />
                  </div>
                  <label>Store description</label>
                  <vue-editor v-model="form.about"></vue-editor>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label class="col-form-label pt-0">Logo Upload <span>*</span></label>
                    <!-- Le logo en cours d'enregistrement est affiché ici :
                         l'aperçu du dropzone ne peut pas le montrer. -->
                    <div class="mb-2" v-if="form.logo">
                      <img :src="form.logo" alt="Current logo" style="max-height: 70px; max-width: 100%;" />
                    </div>
                    <vue-dropzone id="ImagesLogo" :options="ImagesAddLogoOptions" class="dropzone digits" ref="ImagesLogo"
                      :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess"
                      v-on:vdropzone-removed-file="fileRemoved" @vdropzone-file-added="logoFileAdded">
                    </vue-dropzone>
                    <small class="d-block text-muted" v-if="pendingLogoUpload">Uploading the logo...</small>
                    <small class="d-block text-muted" v-else-if="form.logo">Logo stored. Click Save to apply it to the store.</small>
                  </div>
                  <div class="form-group">
                    <label for="validationstoreecurrency" class="col-form-label pt-0">Store currency</label>
                    <select class="custom-select" required="" v-model="form.currency">
                      <option value="EUR">EUR</option>
                      <option value="USD">USD</option>
                      <option value="MAD">MAD</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="validationstoresymbol" class="col-form-label pt-0">Store currency symbol
                      <span>*</span></label>
                    <ValidationProvider name="symbol" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstoresymbol" type="text" v-model="form.symbol"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="validationstorecurrencyrate" class="col-form-label pt-0">Store currency rate
                      <span>*</span></label>
                    <ValidationProvider name="rate" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstorecurrencyrate" type="number" v-model="form.rate"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label"><span>*</span> Language</label>
                    <select class="custom-select" required="" v-model="form.language">
                      <option value="English">English</option>
                      <option value="Frensh">Frensh</option>
                      <option value="Arabic">Arabic</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="validationstoremetatitle" class="col-form-label pt-0">Meta Title
                      <span>*</span></label>
                    <ValidationProvider name="metaTitle" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstoremetadescription" type="text" v-model="form.metaTitle"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="validationstoremetadescription" class="col-form-label pt-0">Meta Description
                      <span>*</span></label>
                    <ValidationProvider name="metaDescription" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstoremetatitle" type="text" v-model="form.metaDescription"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="validationstoremetakeyword" class="col-form-label pt-0">Meta Keyword
                      <span>*</span></label>
                    <ValidationProvider name="metaKeyword" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstoremetakeyword" type="text" v-model="form.metaKeywords"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12 pb-3">
            <div class="form-group mb-0">
              <div class="product-buttons text-right">
                <button type="button" class="btn btn-light mr-2" @click="back">
                  Cancel
                </button>
                <button type="button" class="btn btn-primary" @click="save">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders } from './../../../utils/imageUpload';
import { VueEditor } from "vue2-editor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import sliderModalAdd from "./../sliders/sliderModalAdd.vue";
import sliderModalEdit from "./../sliders/sliderModalEdit.vue";
import Categories from "./../categories/categories.vue";
import { uuid } from "vue-uuid";
export default {
  components: { sliderModalAdd, sliderModalEdit, Categories, VueEditor },
  data() {
    return {
      form: {
        id: null,
        title: "Store name",
        host: "your-domaine-name.com",
        logo: null,
        email: "your-email-company@mail.com",
        adresse: "your adresse business",
        status: true,
        currency: "EUR",
        symbol: "€",
        rate: 1,
        language: "English",
        header: "Header 1",
        footer: "Footer 1",
        box: "Box 2",
        productsPage: "Left Sidebar",
        collections: "Left Sidebar",
        addtocart: "Right",
        showtopbar: true,
        showreview: false,
        shownewsletterpopup: true,
        SingleProduct: false,
        affiliation: false,
        information: "Worldwide Free Shipping",
        checkcashondelevery: true,
        scriptfacebook: "",
        facebookpageid: "",
        facebook: "",
        Headscriptgoogletags: "Script google tag in head",
        Bodyscriptgoogletags: "Script google tag in body",
        youtube: "",
        twitterpageid: "",
        twitter: "",
        instagram: "",
        whatsapp: "",
        checkwhatsapp: false,
        checkpaypal: false,
        checkstripe: false,
        paypalkey: "",
        stripekey: "",
        serviceid: "",
        templateid: "",
        replayto: "",
        sms: false,
        smsglobalkey: "",
        smsglobalsecret: "",
        smsmessage: "",
        freeshipping: true,
        checkcostshipping: false,
        costshipping: 0,
        delailivraison: 0,
        autosolde: false,
        sliders: [],
        categories: [],
        products: [],
        RelatedProducts: true,
        StickAddToCart: true,
        AddToCartText: 'Buy Now',
        catbanners: true,
        dateofdelevery: true,
        metaTitle: '',
        metaDescription: '',
        metaKeywords: '',
        emailConfig:{
                    host:'',
                    port:'',
                    secure:true,
                    user:'',
                    pass:'',
                    thankyou:'',
                    abondoned:'',
                    shipped:'',
                    delivered:'',
                    cencelled:''
                }
      },
      color1:'#ffffff',
      color2:'#f3f6f9',
      BackgroundColor:'#f3f6f9',
      BtnColor:'#ffffff',
      BtnBgColor:'#000000',
      BtnBorderColor:'#000000',
      BtnHoverColor:'#ffffff',
      BtnHoverBgColor:'#000000',
      BtnHoverBorderColor:'#000000',
      BtnActiveColor:'#ffffff',
      BtnActiveBgColor:'#000000',
      BtnActiveBorderColor:'#000000',
      BtnDisabledColor:'#000000',
      BtnDaisbledBgColor:'#f3f6f9',
      BtnDesabledBoredColor:'#f3f6f9',
      message: "",
      error: 0,
      pendingLogoUpload: null,
      editor: ClassicEditor,
      ImagesAddLogoOptions: {
        // Dropzone exige une `url`, mais autoProcessQueue est désactivé :
        // aucun fichier n'est envoyé par le composant. L'envoi vers Firebase
        // Storage est fait directement dans logoFileAdded.
        url: "/no-op",
        autoProcessQueue: false,
        thumbnailWidth: 300,
        thumbnailHeight: 70,
        maxFiles: 1,
        maxfilesexceeded: function (file) {
          this.removeAllFiles();
          this.addFile(file);
        },
        accept: function (file, done) {
          done();
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
      },
      tablefields: [
        { key: "image", label: "Image", sortable: false },
        { key: "actions" }
      ],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      slider: "",
      sliderid: "",
      index: null,
      selectMode: "single",
      showPreview: false,
      imagePreview: null,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    selectedRows() {
      return this.form.sliders.filter(item => item.delete);
    }
  },
  methods: {
    async save() {
      // Un envoi de logo peut être en cours (l'image part dès que le fichier
      // est déposé) : on l'attend pour ne pas enregistrer l'ancienne URL.
      if (this.pendingLogoUpload) await this.pendingLogoUpload;
      if ((this.form.title == "") || (this.form.host == "") || (this.form.logo == "") || (this.form.symbol == "") || (this.form.rate == "")) {
        this.message = "Please complete all required fields!";
        this.error = 1;
        this.$refs["StoreAddAlert"].show();
        return false;
      } else {
        this.error = 0;
      }
      this.form.id=this.form.host;
      let ref = await firebase.firestore().collection('Sites').doc(this.form.host).set(this.form)
        .then((refDoc) => {
          this.message = "Document successfully written!";
          this.error = 0;
          this.$refs['StoreAddAlert'].show()
          // Prévient la page des stores pour afficher la nouvelle ligne sans
          // recharger. Copie obligatoire : le formulaire est remis à zéro à la
          // fermeture de la fenêtre (@hide="clear") et l'original resterait
          // partagé avec la liste.
          this.$emit('ok', Object.assign({}, this.form));
        })
        .catch((error) => {
          this.message = "Error writing document: " + error;
          this.error = 1;
          this.$refs['StoreAddAlert'].show()
        });
    },
    close() {
      if (this.error == 0) this.$bvModal.hide("modal-StoreAdd");
    },
    back() {
      this.$bvModal.hide("modal-StoreAdd");
    },
    getIndex(id) {
      this.sliderid = id;
    },
    async deleteRow(id) {
      this.form.sliders.splice(id, 1);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formData(e) {
      this.form.sliders.push(e);
    },
    OnShowModal() {
      // Le dropzone garde ses aperçus d'une ouverture à l'autre : on le vide
      // pour repartir d'une zone propre (le logo enregistré est affiché
      // au-dessus, via form.logo).
      if (this.$refs.ImagesLogo) this.$refs.ImagesLogo.removeAllFiles();
    },
    clear() {
      this.form.title = "Store name",
        this.form.host = "your-domaine-name.com",
        this.form.id="",
        this.form.logo = null,
        this.form.email = "your-email-company@mail.com",
        this.form.adresse = "your adresse business",
        this.form.status = true,
        this.form.currency = "EUR",
        this.form.symbol = "€",
        this.form.rate = 1,
        this.form.language = "English",
        this.form.header = "Header 1",
        this.form.footer = "Footer 1",
        this.form.box = "Box 1",
        this.form.products = "Left Sidebar",
        this.form.collections = "Left Sidebar",
        this.form.addtocart = "Right",
        this.form.showtopbar = true,
        this.form.showreview = false,
        this.form.shownewsletterpopup = true,
        this.form.information = "Worldwide Free Shipping",
        this.form.checkcashondelevery = true,
        this.form.scriptfacebook = "",
        this.form.facebookpageid = "",
        this.form.facebook = "",
        this.form.scriptgoogletags = "Script google tag",
        this.form.youtube = "",
        this.form.twitterpageid = "",
        this.form.twitter = "",
        this.form.instagram = "",
        this.form.whatsapp = "",
        this.form.checkwhatsapp = false,
        this.form.checkpaypal = false,
        this.form.checkstripe = false,
        this.form.paypalkey = "",
        this.form.stripekey = "",
        this.form.serviceid = "",
        this.form.templateid = "",
        this.form.replayto = "",
        this.form.sms = false,
        this.form.smsglobalkey = "",
        this.form.smsglobalsecret = "",
        this.form.smsmessage = "",
        this.form.freeshipping = true,
        this.form.checkcostshipping = false,
        this.form.costshipping = 0,
        this.form.delailivraison = 0,
        this.form.autosolde = false,
        this.form.sliders = [],
        this.form.categories = [],
        this.form.metaTitle = '',
        this.form.metaDescription = '',
        this.form.Keywords = ''
    },
    updateformData(e) {
      this.form.sliders[e.id] = e
      this.$refs.tableSlider.refresh();
    },
    // Déclenché dès qu'un fichier est déposé : on lit le fichier nous-mêmes
    // (plus aucune dépendance au POST httpbin du template) et on l'envoie
    // vers l'API Hermes (stockage disque api/uploads).
    logoFileAdded(file) {
      if (!file || file._logoHandled) return;
      if (file.type && file.type.indexOf("image/") !== 0) return;
      if (file.size && file.size > 104857600) return;
      file._logoHandled = true;
      const upload = this.storeLogoFile(file);
      this.pendingLogoUpload = upload;
      upload.then(() => {
        if (this.pendingLogoUpload === upload) this.pendingLogoUpload = null;
      });
    },
    async storeLogoFile(file) {
      try {
        const dataURI = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = () => reject(reader.error || new Error("unreadable file"));
          reader.readAsDataURL(file);
        });
        this.form.logo = await this.get_url(this.dataURItoBlob(dataURI), file.name);
      } catch (error) {
        this.message = "Logo upload failed: " + error;
        this.error = 1;
        this.$refs["StoreAddAlert"].show();
      }
    },
    fileRemoved() {

    },
    uploadSuccess() {

    },
    imageResize(base64Str) {
      let img = new Image();
      img.src = base64Str;
      let canvas = document.createElement('canvas');
      let MAX_WIDTH = 300;
      let MAX_HEIGHT = 50;
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      //return canvas.dataURL;
      return canvas.toDataURL();
    },
    ok(e) {
      this.form.categories = e;
    }, dataURItoBlob(dataURI) {
          // Extract the base64-encoded data from the Data URI
          var byteString = atob(dataURI.split(',')[1]);

          // Create an ArrayBuffer to hold the binary data
          var buffer = new ArrayBuffer(byteString.length);

          // Create a typed array from the buffer
          var uint8Array = new Uint8Array(buffer);

          // Populate the typed array with the binary data
          for (var i = 0; i < byteString.length; i++) {
              uint8Array[i] = byteString.charCodeAt(i);
          }

          // Create a Blob from the ArrayBuffer, specifying the MIME type as 'image/webp'
          return new Blob([uint8Array], { type: 'image/webp' });
      },
    async get_url(file, filename) {
      // Téléversement vers l'API Hermes (stockage sur le disque du
      // serveur, dossier api/uploads) : remplace Firebase Storage
      // dont le bucket a dépassé le quota du plan gratuit Spark.
      if (!file) {
        return null;
      }
      // L'API refuse aussi # [ ] * ? dans les noms de fichiers.
      const safeName = String(filename || 'logo').replace(/[#\[\]*?]/g, '-');
      const ext = file.type === 'image/png' ? '.png' : '.webp';
      const form = new FormData();
      form.append('folder', 'sites/' + this.form.host + '/logo');
      form.append('file', file, safeName + ext);
      const res = await fetch(uploadUrl, { method: 'POST', headers: uploadHeaders(), body: form });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Erreur ' + res.status + ' : /api/uploads injoignable (API Hermes démarrée ? proxy /api actif ?)');
      return data.url;
    }
  }
};
</script>
<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>